import {SPORTFILTER_SET_FILTER} from 'store/actionTypes';
import {SportFilterState, SportFilterAction} from './types';

// TODO: documentation
// BIQ: is this the proper way to initialize state, or should it be in hook?
const initialState: SportFilterState = {
  filter: 'top',
};

const sportFilterReducer = (state = initialState, action: SportFilterAction): SportFilterState => {
  switch (action.type) {
    case SPORTFILTER_SET_FILTER:
      return {
        ...state,
        filter: action.payload.filter ?? 'top',
      };
    default:
      return state;
  }
};

export default sportFilterReducer;
